/**
 * Utility functions for tasks.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { JobDetail, TextUtil } from '@amplify3/duplo-back-end'

export class TaskUtil {
  /** Returns the formatted status string for a job. */
  static jobDetailToStatusFormattedString(job: JobDetail) {
    return TaskUtil.jobStatusToFormattedString(job.job_status)
  }

  /** Maps a raw job status string to a human-readable label. */
  static jobStatusToFormattedString(status?: string) {
    switch (status) {
      case 'success':
        return 'Complete'

      case 'error':
        return 'Failed'

      case 'running':
        return 'Running'

      case 'created':
        return 'Queued'

      default:
        return TextUtil.capitalizeFirstChar(status)
    }
  }
}
